import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import RawHtml from '../RawHtml';

const RedirectCss = `
  font-weight: 500;

  a {
    font-weight: 600;
    color: #1abc9c;
  }
`;

export const Redirect = ({
  url,
  target,
  label,
  milliseconds,
  openOnlyWithClick
}) => {
  const [seconds, setSeconds] = useState(Math.ceil(milliseconds / 1000));

  const parsedLabel = useMemo(() => {
    return label
      .replaceAll('$SECONDS', seconds)
      .replaceAll(
        '$LINK',
        `<a href='${url}' target='${target}'>clique aqui</a>`
      );
  }, [seconds, label, url, target]);

  useEffect(() => {
    const redirect = setTimeout(
      () => {
        if (!openOnlyWithClick) {
          if (target === '_blank') {
            const newTab = window.open();
            newTab.location.href = url;
          } else {
            window.open(url, '_self');
          }
        }
      },
      milliseconds > 0 ? milliseconds : 0
    );

    return () => {
      clearTimeout(redirect);
    };
  }, []);

  useEffect(() => {
    let countdown;

    if (seconds > 0) {
      countdown = setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    }

    return () => {
      clearTimeout(countdown);
    };
  }, [seconds]);

  return (
    <div className={css`${RedirectCss}`}>
      {label && <RawHtml>{parsedLabel}</RawHtml>}
    </div>
  );
};

Redirect.propTypes = {
  url: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_self']),
  label: PropTypes.string,
  milliseconds: PropTypes.number,
  openOnlyWithClick: PropTypes.bool
};

Redirect.defaultProps = {
  url: '#',
  target: '_self',
  label:
    'Você será redirecionado em $SECONDS segundos. Se não quiser esperar, $LINK.',
  milliseconds: 5000
};

export default Redirect;
